import { render, staticRenderFns } from "./topalerts.vue?vue&type=template&id=1d184fcc"
import script from "./topalerts.vue?vue&type=script&lang=js"
export * from "./topalerts.vue?vue&type=script&lang=js"
import style0 from "./topalerts.vue?vue&type=style&index=0&id=1d184fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports